// Alto de la cabecera fija. El PageContainer lo descuenta del viewport para que su contenido
// empiece justo debajo. El pie fijo se eliminó: era decorativo y en teléfono se comía 30px.
const ALTO_CABECERA_PX = 70

const layoutTypes = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
}

const layoutWidthTypes = {
  FLUID: 'fluid',
  BOXED: 'boxed',
  SCROLLABLE: 'scrollable',
}

const topBarThemeTypes = {
  LIGHT: 'light',
  DARK: 'dark',
  COLORED: 'colored',
}

const leftBarThemeImageTypes = {
  NONE: 'none',
  IMG1: 'img1',
  IMG2: 'img2',
  IMG3: 'img3',
  IMG4: 'img4',
}

const leftSidebarTypes = {
  DEFAULT: 'default',
  COMPACT: 'compact',
  ICON: 'icon',
}

const leftSideBarThemeTypes = {
  LIGHT: 'light',
  COLORED: 'colored',
  DARK: 'dark',
  WINTER: 'winter',
  LADYLIP: 'ladylip',
  PLUMPLATE: 'plumplate',
  STRONGBLISS: 'strongbliss',
  GREATWHALE: 'greatwhale',
}

export {
  ALTO_CABECERA_PX,
  layoutTypes,
  layoutWidthTypes,
  topBarThemeTypes,
  leftBarThemeImageTypes,
  leftSidebarTypes,
  leftSideBarThemeTypes,
}
// 669ac662-3f93-47f2-82fc-9819cb578ea1
